import React from 'react';
import Chip from '@mui/material/Chip';

import './chip.scss';
import { Tooltip } from '@mui/material';
const locale = "es-ES";

export const CustomChip = ({
    label,
    icon,
    onClick,
    isYellow = false,
    isGreen = false,
    isRed = false,
    isBlack = false,
    isLightBlue = false,
    isViolet = false,
    isGray = false,
    isLightGray = false,
    isBlue = false,
    isMultiLine = false,
    title = '',
    sx
}) => {

    const defaultSX = (isMultiLine) ? { '& .MuiChip-label': { display: 'block', whiteSpace: 'normal' } } : {};

    const chip = <Chip
                    label={label}
                    className={
                        `
                        ${isYellow ? 'yellow-chip' : ''}
                        ${isGreen ? 'green-chip' : ''}
                        ${isRed ? 'red-chip' : ''}
                        ${isBlack ? 'black-chip' : ''}
                        ${isViolet ? 'violet-chip' : ''}
                        ${isGray ? 'gray-chip' : ''}
                        ${isBlue ? 'blue-chip' : ''}
                        ${isLightBlue ? 'lightblue-chip' : ''}
                        ${isLightGray ? '.lightgray-chip' : ''}`
                    }
                    icon={icon}
                    onClick={onClick}
                    sx={{
                        height: 21,
                        fontSize: 11,
                        ...defaultSX,
                        ...sx
                    }}
                />

    return (
        <div className='chip-container'>
            { (title!='') && <Tooltip title={title} placement="bottom">{chip}</Tooltip>}
            { (title=='') && chip }
        </div>
    )
}